webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(2)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ },
/* 2 */
/***/ function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ },
/* 3 */
/***/ function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 4 */
/***/ function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wx.e41667b2.png";

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 11 */
/***/ function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(37);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ },
/* 13 */
/***/ function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(12)
  , defined = __webpack_require__(11);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google-cloud.42efc4f1.png";

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/studio.cccfe867.png";

/***/ },
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(23);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return app; });






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_1_vue___default.a(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_3__components_App___default.a));



/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);

window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ },
/* 21 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Tool__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Tool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Tool__);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

/* harmony default export */ exports["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  mode: 'hash',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: '/tool',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Tool___default.a
  }]
});

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex___default.a);

var state = {
  count: 0
};

var mutations = {
  INCREMENT: function INCREMENT(state) {
    state.count++;
  },
  DECREMENT: function DECREMENT(state) {
    state.count--;
  }
};

var actions = {
  incrementAsync: function incrementAsync(_ref) {
    var commit = _ref.commit;

    setTimeout(function () {
      commit('INCREMENT');
    }, 200);
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex___default.a.Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ exports["a"] = store;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ exports["default"] = {
  props: ['pageBoolean', 'meanList'],
  data: function data() {
    return {
      progressWidth: {
        width: 0
      },
      pageText: {
        time: 0,
        pageTexts: ['first', 'second', 'third']
      },
      pageClass: {
        pageNow: 'first',
        pageNowNum: 0
      },
      currentBoolean: {
        isFullPlay: false,
        toggleFullPlay: false,
        toggleFullPlayMuted: false,
        isThree: false,
        isTwo: false,
        isOne: true
      }
    };
  },

  methods: {
    turnRight: function turnRight() {
      var index = 0;
      this.pageClass.pageNowNum++;
      index = this.pageClass.pageNowNum % 3;
      this.turnPage(index);
    },
    turnLeft: function turnLeft() {
      var index = 0;
      this.pageClass.pageNowNum--;
      index = this.pageClass.pageNowNum % 3;
      this.turnPage(index);
    },
    turnPage: function turnPage(index) {
      if (index == 0) {
        this.currentBoolean.isOne = true;
        this.currentBoolean.isTwo = false;
        this.currentBoolean.isThree = false;
      } else if (index == 1) {
        this.currentBoolean.isOne = false;
        this.currentBoolean.isTwo = true;
        this.currentBoolean.isThree = false;
      } else if (index == 2) {
        this.currentBoolean.isOne = false;
        this.currentBoolean.isTwo = false;
        this.currentBoolean.isThree = true;
      }
      this.pageClass.pageNow = this.pageText.pageTexts[index];
    },
    canplay: function canplay() {
      var video = document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad = false;
      video.style.width = window.innerWidth + 'px';
      video.play();
    },
    toggleFullPlay: function toggleFullPlay() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay = !this.currentBoolean.toggleFullPlay;
      if (this.currentBoolean.toggleFullPlay) {
        this.progressBarVal();
        fullVideo.pause();
      } else {
        fullVideo.play();
      }
    },
    toggleFullPlayMuted: function toggleFullPlayMuted() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted = !this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted = this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay: function canFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay: function closeFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = false;
      this.currentBoolean.toggleFullPlay = false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal: function progressBarVal() {
      var fullVideo = document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time = this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width = (fullVideo.currentTime / fullVideo.duration * 100).toFixed(5) + '%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar: function getProgressBar(e) {
      var fullVideo = document.getElementById('fullVideo'),
          fullBar = document.getElementById('fullBar'),
          precent = (e.clientX / fullBar.clientWidth).toFixed(5),
          currentTime = 0;
      currentTime = fullVideo.duration * precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime = currentTime;
      //console.log(currentTime);
    },
    showTime: function showTime(time) {
      var timeStr = "";
      if (time < 10) {
        timeStr = "0:0" + time;
      } else if (time < 60) {
        timeStr = "0:" + time;
      } else {
        if (time % 60 < 10) {
          timeStr = Math.floor(time / 60) + ":0" + time % 60;
        } else {
          timeStr = Math.floor(time / 60) + ":" + time % 60;
        }
      }
      return timeStr;
    }
  }
};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ exports["default"] = {
  props: ['pageBoolean', 'meanList'],
  data: function data() {
    return {
      progressWidth: {
        width: 0
      },
      pageText: {
        time: 0
      },
      currentBoolean: {
        isFullPlay: false,
        toggleFullPlay: false,
        toggleFullPlayMuted: false
      }
    };
  },

  methods: {
    canplay: function canplay() {
      var video = document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad = false;
      video.style.width = window.innerWidth + 'px';
      video.play();
    },
    toggleFullPlay: function toggleFullPlay() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay = !this.currentBoolean.toggleFullPlay;
      if (this.currentBoolean.toggleFullPlay) {
        this.progressBarVal();
        fullVideo.pause();
      } else {
        fullVideo.play();
      }
    },
    toggleFullPlayMuted: function toggleFullPlayMuted() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted = !this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted = this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay: function canFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay: function closeFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = false;
      this.currentBoolean.toggleFullPlay = false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal: function progressBarVal() {
      var fullVideo = document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time = this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width = (fullVideo.currentTime / fullVideo.duration * 100).toFixed(5) + '%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar: function getProgressBar(e) {
      var fullVideo = document.getElementById('fullVideo'),
          fullBar = document.getElementById('fullBar'),
          precent = (e.clientX / fullBar.clientWidth).toFixed(5),
          currentTime = 0;
      currentTime = fullVideo.duration * precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime = currentTime;
      //console.log(currentTime);
    },
    showTime: function showTime(time) {
      var timeStr = "";
      if (time < 10) {
        timeStr = "0:0" + time;
      } else if (time < 60) {
        timeStr = "0:" + time;
      } else {
        if (time % 60 < 10) {
          timeStr = Math.floor(time / 60) + ":0" + time % 60;
        } else {
          timeStr = Math.floor(time / 60) + ":" + time % 60;
        }
      }
      return timeStr;
    }
  }
};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ exports["default"] = {
  props: ['pageBoolean', 'meanList'],
  data: function data() {
    return {
      progressWidth: {
        width: 0
      },
      pageText: {
        time: 0
      },
      currentBoolean: {
        isFullPlay: false,
        toggleFullPlay: false,
        toggleFullPlayMuted: false
      }
    };
  },

  methods: {
    canplay: function canplay() {
      var video = document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad = false;
      video.style.width = window.innerWidth + 'px';
      video.play();
    },
    toggleFullPlay: function toggleFullPlay() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay = !this.currentBoolean.toggleFullPlay;
      if (this.currentBoolean.toggleFullPlay) {
        this.progressBarVal();
        fullVideo.pause();
      } else {
        fullVideo.play();
      }
    },
    toggleFullPlayMuted: function toggleFullPlayMuted() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted = !this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted = this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay: function canFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay: function closeFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = false;
      this.currentBoolean.toggleFullPlay = false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal: function progressBarVal() {
      var fullVideo = document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time = this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width = (fullVideo.currentTime / fullVideo.duration * 100).toFixed(5) + '%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar: function getProgressBar(e) {
      var fullVideo = document.getElementById('fullVideo'),
          fullBar = document.getElementById('fullBar'),
          precent = (e.clientX / fullBar.clientWidth).toFixed(5),
          currentTime = 0;
      currentTime = fullVideo.duration * precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime = currentTime;
      //console.log(currentTime);
    },
    showTime: function showTime(time) {
      var timeStr = "";
      if (time < 10) {
        timeStr = "0:0" + time;
      } else if (time < 60) {
        timeStr = "0:" + time;
      } else {
        if (time % 60 < 10) {
          timeStr = Math.floor(time / 60) + ":0" + time % 60;
        } else {
          timeStr = Math.floor(time / 60) + ":" + time % 60;
        }
      }
      return timeStr;
    }
  }
};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ exports["default"] = {
  props: ['pageBoolean', 'meanList'],
  data: function data() {
    return {
      progressWidth: {
        width: 0
      },
      pageText: {
        time: 0
      },
      currentBoolean: {
        isFullPlay: false,
        toggleFullPlay: false,
        toggleFullPlayMuted: false
      }
    };
  },

  methods: {
    canplay: function canplay() {
      var video = document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad = false;
      video.style.width = window.innerWidth + 'px';
      video.play();
    },
    toggleFullPlay: function toggleFullPlay() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay = !this.currentBoolean.toggleFullPlay;
      if (this.currentBoolean.toggleFullPlay) {
        this.progressBarVal();
        fullVideo.pause();
      } else {
        fullVideo.play();
      }
    },
    toggleFullPlayMuted: function toggleFullPlayMuted() {
      var fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted = !this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted = this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay: function canFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay: function closeFullPlay() {
      var video = document.getElementById('loopVideo'),
          fullVideo = document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay = false;
      this.currentBoolean.toggleFullPlay = false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal: function progressBarVal() {
      var fullVideo = document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time = this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width = (fullVideo.currentTime / fullVideo.duration * 100).toFixed(5) + '%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar: function getProgressBar(e) {
      var fullVideo = document.getElementById('fullVideo'),
          fullBar = document.getElementById('fullBar'),
          precent = (e.clientX / fullBar.clientWidth).toFixed(5),
          currentTime = 0;
      currentTime = fullVideo.duration * precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime = currentTime;
      //console.log(currentTime);
    },
    showTime: function showTime(time) {
      var timeStr = "";
      if (time < 10) {
        timeStr = "0:0" + time;
      } else if (time < 60) {
        timeStr = "0:" + time;
      } else {
        if (time % 60 < 10) {
          timeStr = Math.floor(time / 60) + ":0" + time % 60;
        } else {
          timeStr = Math.floor(time / 60) + ":" + time % 60;
        }
      }
      return timeStr;
    }
  }
};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ exports["default"] = {
   data: function data() {
      return {
         allSite: [{
            website: [{
               name: '浏览器↓↓↓',
               items: [{
                  title: 'Chrome',
                  url: __webpack_require__(82),
                  href: 'https://www.google.com/chrome/'
               }, {
                  title: 'Firefox',
                  url: __webpack_require__(97),
                  href: 'https://www.mozilla.org/en-US/firefox/products/'
               }, {
                  title: 'Safari',
                  url: __webpack_require__(182),
                  href: 'http://www.apple.com/safari/'
               }, {
                  title: 'Opera',
                  url: __webpack_require__(162),
                  href: 'http://www.opera.com/'
               }, {
                  title: 'IE',
                  url: __webpack_require__(92),
                  href: 'https://www.microsoft.com/zh-cn/windows/microsoft-edge/'
               }]
            }, {
               name: '搜索引擎服务/代码版本管理↓↓↓',
               items: [{
                  title: 'Google',
                  url: __webpack_require__(105),
                  href: 'https://www.google.com/'
               }, {
                  title: 'Baidu',
                  url: __webpack_require__(73),
                  href: 'https://www.baidu.com/'
               }, {
                  title: 'Git',
                  url: __webpack_require__(101),
                  href: 'http://git-scm.com/'
               }, {
                  title: 'Mercurial',
                  url: __webpack_require__(145),
                  href: 'https://www.mercurial-scm.org/'
               }, {
                  title: 'SVN',
                  url: __webpack_require__(200),
                  href: 'http://subversion.apache.org/'
               }]
            }, {
               name: '翻墙工具/免费VPN↓↓↓',
               items: [{
                  title: 'Lantern',
                  url: __webpack_require__(133),
                  href: 'https://github.com/getlantern/lantern/'
               }, {
                  title: 'XX-Net',
                  url: __webpack_require__(217),
                  href: 'https://github.com/XX-net/XX-Net/'
               }, {
                  title: 'Tor',
                  url: __webpack_require__(205),
                  href: 'https://www.torproject.org/'
               }, {
                  title: 'Softether',
                  url: __webpack_require__(193),
                  href: 'https://www.softether.org/'
               }, {
                  title: 'Shadowsocks',
                  url: __webpack_require__(190),
                  href: 'https://shadowsocks.org/'
               }]
            }]
         }, {
            website: [{
               name: '代码托管及在线开发↓↓↓',
               items: [{
                  title: 'Github',
                  url: __webpack_require__(102),
                  href: 'https://github.com/'
               }, {
                  title: 'Coding',
                  url: __webpack_require__(84),
                  href: 'https://coding.net/'
               }, {
                  title: 'Bitbucket',
                  url: __webpack_require__(75),
                  href: 'http://www.bitbucket.org/'
               }, {
                  title: 'Gitlab',
                  url: __webpack_require__(103),
                  href: 'http://gitlab.com/'
               }, {
                  title: 'JSFiddle',
                  url: __webpack_require__(129),
                  href: 'http://jsfiddle.net/'
               }, {
                  title: 'CodePen',
                  url: __webpack_require__(83),
                  href: 'https://codepen.io/'
               }]
            }, {
               name: '热门前端框架↓↓↓',
               items: [{
                  title: 'Vue',
                  url: __webpack_require__(211),
                  href: 'https://vuefe.cn/v2/guide/'
               }, {
                  title: 'Angular',
                  url: __webpack_require__(65),
                  href: 'http://angular.io/'
               }, {
                  title: 'React',
                  url: __webpack_require__(177),
                  href: 'http://facebook.github.io/react/'
               }, {
                  title: 'JQuery',
                  url: __webpack_require__(127),
                  href: 'http://jquery.com/'
               }, {
                  title: 'JQuery Mobile',
                  url: __webpack_require__(128),
                  href: 'http://jquerymobile.com/'
               }, {
                  title: '微信小程序',
                  url: __webpack_require__(5),
                  href: 'https://mp.weixin.qq.com/debug/wxadoc/dev/index.html'
               }]
            }, {
               name: '编辑器及Markdown在线编辑器↓↓↓',
               items: [{
                  title: 'Sublime',
                  url: __webpack_require__(198),
                  href: 'http://www.sublimetext.com/'
               }, {
                  title: 'Notepad++',
                  url: __webpack_require__(160),
                  href: 'https://notepad-plus-plus.org/'
               }, {
                  title: 'Vim',
                  url: __webpack_require__(209),
                  href: 'http://www.vim.org/'
               }, {
                  title: 'Emacs',
                  url: __webpack_require__(93),
                  href: 'http://www.gnu.org/software/emacs/'
               }, {
                  title: 'MaHua',
                  url: __webpack_require__(142),
                  href: 'http://mahua.jser.me/'
               }, {
                  title: 'ZYBuLuo',
                  url: __webpack_require__(224),
                  href: 'https://www.zybuluo.com/'
               }]
            }]
         }, {
            website: [{
               name: '开发语言↓↓↓',
               items: [{
                  title: 'Java',
                  url: __webpack_require__(123),
                  href: 'https://www.java.com/zh_CN/'
               }, {
                  title: 'JavaScript-Nodejs',
                  url: __webpack_require__(157),
                  href: 'http://nodejs.org/'
               }, {
                  title: 'Python',
                  url: __webpack_require__(173),
                  href: 'https://www.python.org/'
               }, {
                  title: 'Php',
                  url: __webpack_require__(166),
                  href: 'http://php.net/'
               }, {
                  title: 'Ruby',
                  url: __webpack_require__(181),
                  href: 'https://www.ruby-lang.org/'
               }, {
                  title: 'Swift',
                  url: __webpack_require__(201),
                  href: 'https://developer.apple.com/swift/'
               }, {
                  title: 'Go',
                  url: __webpack_require__(104),
                  href: 'https://developer.apple.com/swift/'
               }]
            }, {
               name: '常用IDE↓↓↓',
               items: [{
                  title: 'WebStorm',
                  url: __webpack_require__(213),
                  href: 'https://www.jetbrains.com/webstorm/'
               }, {
                  title: 'HBuilder',
                  url: __webpack_require__(112),
                  href: 'http://www.dcloud.io/'
               }, {
                  title: 'Atom',
                  url: __webpack_require__(68),
                  href: 'https://atom.io/'
               }, {
                  title: 'Eclipse',
                  url: __webpack_require__(91),
                  href: 'https://eclipse.org/'
               }, {
                  title: 'Visual Studio',
                  url: __webpack_require__(210),
                  href: 'https://code.visualstudio.com/'
               }, {
                  title: 'NetBeans',
                  url: __webpack_require__(153),
                  href: 'https://netbeans.org/'
               }, {
                  title: 'Android-Studio',
                  url: __webpack_require__(16),
                  href: 'http://developer.android.com/sdk/index.html'
               }, {
                  title: 'XCode',
                  url: __webpack_require__(216),
                  href: 'https://developer.apple.com/xcode/ide/'
               }]
            }]
         }, {
            website: [{
               name: '常用UI框架↓↓↓',
               items: [{
                  title: 'Bootstrap',
                  url: __webpack_require__(77),
                  href: 'http://getbootstrap.com/'
               }, {
                  title: 'Semantic UI',
                  url: __webpack_require__(188),
                  href: 'http://semantic-ui.com/'
               }, {
                  title: 'Purecss',
                  url: __webpack_require__(172),
                  href: 'http://purecss.io/'
               }, {
                  title: 'FrozenUI',
                  url: __webpack_require__(99),
                  href: 'http://frozenui.github.io/'
               }, {
                  title: 'WeUI',
                  url: __webpack_require__(5),
                  href: 'https://weui.io/'
               }, {
                  title: 'Win8',
                  url: __webpack_require__(215),
                  href: 'http://metroui.org.ua/'
               }, {
                  title: 'Ionic',
                  url: __webpack_require__(119),
                  href: 'http://ionicframework.com/'
               }, {
                  title: 'Appframework',
                  url: __webpack_require__(118),
                  href: 'https://github.com/01org/appframework/'
               }, {
                  title: 'Polymer',
                  url: __webpack_require__(168),
                  href: 'https://github.com/Polymer/polymer/'
               }]
            }, {
               name: '常用插件/Web字体↓↓↓',
               items: [{
                  title: 'Babel',
                  url: __webpack_require__(72),
                  href: 'https://babeljs.io/'
               }, {
                  title: 'Normalize',
                  url: __webpack_require__(159),
                  href: 'http://necolas.github.io/normalize.css/'
               }, {
                  title: 'Hammer',
                  url: __webpack_require__(110),
                  href: 'http://hammerjs.github.io/'
               }, {
                  title: 'FastClick',
                  url: __webpack_require__(95),
                  href: 'https://github.com/ftlabs/fastclick/'
               }, {
                  title: 'Swiper',
                  url: __webpack_require__(202),
                  href: 'http://idangero.us/swiper/'
               }, {
                  title: 'IScroll',
                  url: __webpack_require__(120),
                  href: 'http://iscrolljs.com/'
               }, {
                  title: 'Font Awesome',
                  url: __webpack_require__(98),
                  href: 'http://fontawesome.io/'
               }, {
                  title: 'Icon Font',
                  url: __webpack_require__(116),
                  href: 'http://iconfont.cn/'
               }]
            }]
         }, {
            website: [{
               name: '模块化/构建/预处理器↓↓↓',
               items: [{
                  title: 'Require',
                  url: __webpack_require__(180),
                  href: 'http://requirejs.org/'
               }, {
                  title: 'Sea',
                  url: __webpack_require__(186),
                  href: 'http://seajs.org/docs/'
               }, {
                  title: 'Gulp',
                  url: __webpack_require__(108),
                  href: 'http://gulpjs.com/'
               }, {
                  title: 'Grunt',
                  url: __webpack_require__(107),
                  href: 'http://gruntjs.com/'
               }, {
                  title: 'Yeoman',
                  url: __webpack_require__(219),
                  href: 'http://yeoman.io/'
               }, {
                  title: 'Bower',
                  url: __webpack_require__(78),
                  href: 'https://bower.io/'
               }, {
                  title: 'Webpack',
                  url: __webpack_require__(212),
                  href: 'https://webpack.github.io/'
               }, {
                  title: 'Sass',
                  url: __webpack_require__(184),
                  href: 'http://sass-lang.com/'
               }, {
                  title: 'Less',
                  url: __webpack_require__(135),
                  href: 'http://lesscss.org/'
               }, {
                  title: 'Stylus',
                  url: __webpack_require__(197),
                  href: 'http://stylus-lang.com/'
               }]
            }, {
               name: 'NodeJS后端全栈框架↓↓↓',
               items: [{
                  title: 'Express',
                  url: __webpack_require__(94),
                  href: 'http://expressjs.com/'
               }, {
                  title: 'Koa',
                  url: __webpack_require__(132),
                  href: 'http://koajs.com/'
               }, {
                  title: 'Sails',
                  url: __webpack_require__(183),
                  href: 'http://sailsjs.org/'
               }, {
                  title: 'Meteor',
                  url: __webpack_require__(146),
                  href: 'http://www.meteor.com/'
               }, {
                  title: 'Socket',
                  url: __webpack_require__(192),
                  href: 'http://socket.io/'
               }, {
                  title: 'Hapi',
                  url: __webpack_require__(111),
                  href: 'http://hapijs.com/'
               }, {
                  title: 'Loopback',
                  url: __webpack_require__(140),
                  href: 'http://loopback.io/'
               }, {
                  title: 'Pug',
                  url: __webpack_require__(171),
                  href: 'https://pugjs.org/api/getting-started.html'
               }]
            }]
         }, {
            website: [{
               name: '混合移动开发/App技术↓↓↓',
               items: [{
                  title: 'Cordova',
                  url: __webpack_require__(85),
                  href: 'https://cordova.apache.org/'
               }, {
                  title: 'React Native',
                  url: __webpack_require__(176),
                  href: 'https://facebook.github.io/react-native/'
               }, {
                  title: 'NativeScript',
                  url: __webpack_require__(152),
                  href: 'https://www.nativescript.org/'
               }, {
                  title: 'CrossWalk',
                  url: __webpack_require__(86),
                  href: 'https://crosswalk-project.org/'
               }, {
                  title: 'FireBase',
                  url: __webpack_require__(96),
                  href: 'https://www.firebase.com/'
               }]
            }, {
               name: 'BaaS/原型设计/UI↓↓↓',
               items: [{
                  title: 'LeanCloud',
                  url: __webpack_require__(134),
                  href: 'https://leancloud.cn/'
               }, {
                  title: 'Bmob',
                  url: __webpack_require__(76),
                  href: 'http://www.bmob.cn/'
               }, {
                  title: '野狗',
                  url: __webpack_require__(218),
                  href: 'https://www.wilddog.com/'
               }, {
                  title: 'Sketch',
                  url: __webpack_require__(191),
                  href: 'https://sketchapp.com/'
               }, {
                  title: 'Axure',
                  url: __webpack_require__(70),
                  href: 'http://www.axure.com/'
               }, {
                  title: '墨刀',
                  url: __webpack_require__(148),
                  href: 'https://modao.cc/'
               }]
            }, {
               name: '反向代理服务工具↓↓↓',
               items: [{
                  title: 'Ngrok',
                  url: __webpack_require__(156),
                  href: 'https://ngrok.com/'
               }, {
                  title: 'Charles',
                  url: __webpack_require__(81),
                  href: 'https://www.charlesproxy.com/'
               }, {
                  title: 'Localtunnel',
                  url: __webpack_require__(139),
                  href: 'http://localtunnel.me/'
               }, {
                  title: 'Pagekite',
                  url: __webpack_require__(165),
                  href: 'http://pagekite.net/'
               }, {
                  title: 'NATAPP',
                  url: __webpack_require__(151),
                  href: 'https://natapp.cn/'
               }]
            }]
         }, {
            website: [{
               name: '云技术/云主机/云存储/Web服务器↓↓↓',
               items: [{
                  title: 'Digital Ocean',
                  url: __webpack_require__(88),
                  href: 'https://www.digitalocean.com/'
               }, {
                  title: 'Google Cloud',
                  url: __webpack_require__(15),
                  href: 'https://cloud.google.com/'
               }, {
                  title: 'Open Shift',
                  url: __webpack_require__(161),
                  href: 'https://www.openshift.com/'
               }, {
                  title: 'Azure',
                  url: __webpack_require__(71),
                  href: 'http://azure.microsoft.com/'
               }, {
                  title: 'Linode',
                  url: __webpack_require__(137),
                  href: 'https://www.linode.com/'
               }, {
                  title: 'Heroku',
                  url: __webpack_require__(113),
                  href: 'https://www.heroku.com/'
               }, {
                  title: 'Hadoop',
                  url: __webpack_require__(109),
                  href: 'http://hadoop.apache.org/'
               }, {
                  title: 'Google Cloud',
                  url: __webpack_require__(15),
                  href: 'https://cloud.google.com/'
               }, {
                  title: 'Docker',
                  url: __webpack_require__(90),
                  href: 'https://www.docker.com/'
               }, {
                  title: '七牛云',
                  url: __webpack_require__(174),
                  href: 'http://www.qiniu.com/'
               }, {
                  title: 'AliYun',
                  url: __webpack_require__(64),
                  href: 'http://www.aliyun.com/'
               }, {
                  title: 'Aws',
                  url: __webpack_require__(69),
                  href: 'http://aws.amazon.com/'
               }, {
                  title: '腾讯云',
                  url: __webpack_require__(203),
                  href: 'https://www.qcloud.com/'
               }, {
                  title: 'Tomcat',
                  url: __webpack_require__(204),
                  href: 'http://tomcat.apache.org/'
               }, {
                  title: 'IIS',
                  url: __webpack_require__(117),
                  href: 'https://www.iis.net/'
               }, {
                  title: 'Nginx',
                  url: __webpack_require__(155),
                  href: 'https://nginx.org/'
               }]
            }]
         }, {
            website: [{
               name: '数据库/分布式缓存↓↓↓',
               items: [{
                  title: 'MySQL',
                  url: __webpack_require__(150),
                  href: 'http://www.mysql.com/'
               }, {
                  title: 'Oracle',
                  url: __webpack_require__(163),
                  href: 'https://www.oracle.com/index.html'
               }, {
                  title: 'SQL Server',
                  url: __webpack_require__(195),
                  href: 'https://www.microsoft.com/zh-cn/server-cloud/products/sql-server/default.aspx'
               }, {
                  title: 'PostgreSQL',
                  url: __webpack_require__(169),
                  href: 'http://www.postgresql.org/'
               }, {
                  title: 'MongoDB',
                  url: __webpack_require__(149),
                  href: 'https://www.mongodb.org/'
               }, {
                  title: 'MariaDB',
                  url: __webpack_require__(143),
                  href: 'https://mariadb.com/'
               }, {
                  title: 'Lovefield',
                  url: __webpack_require__(141),
                  href: 'https://google.github.io/lovefield/'
               }, {
                  title: 'SQLite',
                  url: __webpack_require__(194),
                  href: 'https://www.sqlite.org/'
               }, {
                  title: 'Memcached',
                  url: __webpack_require__(144),
                  href: 'http://memcached.org/'
               }, {
                  title: 'Redis',
                  url: __webpack_require__(179),
                  href: 'https://redis.io/'
               }, {
                  title: 'Greenplum',
                  url: __webpack_require__(106),
                  href: 'http://greenplum.org/'
               }]
            }]
         }, {
            website: [{
               name: '静态博客↓↓↓',
               items: [{
                  title: 'Hexo',
                  url: __webpack_require__(114),
                  href: 'https://hexo.io/'
               }, {
                  title: 'Jekyllrb',
                  url: __webpack_require__(124),
                  href: 'https://jekyllrb.com/'
               }, {
                  title: 'Surge',
                  url: __webpack_require__(199),
                  href: 'http://surge.sh/'
               }, {
                  title: 'Netlify',
                  url: __webpack_require__(154),
                  href: 'https://www.netlify.com/'
               }]
            }, {
               name: '短信平台↓↓↓',
               items: [{
                  title: 'Twilio',
                  url: __webpack_require__(207),
                  href: 'https://www.twilio.com/'
               }, {
                  title: '7GLink',
                  url: __webpack_require__(63),
                  href: 'http://7glink.com/'
               }, {
                  title: '云片网',
                  url: __webpack_require__(220),
                  href: 'https://www.yunpian.com/'
               }]
            }, {
               name: '移动支付↓↓↓',
               items: [{
                  title: 'Pingxx',
                  url: __webpack_require__(167),
                  href: 'https://www.pingxx.com/'
               }, {
                  title: 'Beecloud',
                  url: __webpack_require__(74),
                  href: 'https://beecloud.cn/'
               }, {
                  title: '支付宝',
                  url: __webpack_require__(222),
                  href: 'https://open.alipay.com/'
               }, {
                  title: '微信',
                  url: __webpack_require__(5),
                  href: 'https://pay.weixin.qq.com/'
               }]
            }, {
               name: '网络安全↓↓↓',
               items: [{
                  title: 'Lets Encrypt',
                  url: __webpack_require__(136),
                  href: 'https://letsencrypt.org/'
               }, {
                  title: 'Node Security',
                  url: __webpack_require__(158),
                  href: 'https://nodesecurity.io/'
               }, {
                  title: 'StartSSL',
                  url: __webpack_require__(196),
                  href: 'https://www.startssl.com/'
               }]
            }]
         }, {
            website: [{
               name: '单元测试/自动化测试/持续集成↓↓↓',
               items: [{
                  title: 'JUnit',
                  url: __webpack_require__(130),
                  href: 'http://junit.org/junit4/'
               }, {
                  title: 'Mocha',
                  url: __webpack_require__(147),
                  href: 'http://mochajs.org/'
               }, {
                  title: 'Jasmine',
                  url: __webpack_require__(122),
                  href: 'http://jasmine.github.io/'
               }, {
                  title: 'Karma',
                  url: __webpack_require__(131),
                  href: 'http://karma-runner.github.io/'
               }, {
                  title: 'QUnit',
                  url: __webpack_require__(175),
                  href: 'http://qunitjs.com/'
               }, {
                  title: 'Selenium',
                  url: __webpack_require__(187),
                  href: 'http://www.seleniumhq.org/'
               }, {
                  title: 'MonkeyRunner',
                  url: __webpack_require__(16),
                  href: 'https://developer.android.com/studio/test/monkeyrunner/'
               }, {
                  title: 'Postman',
                  url: __webpack_require__(170),
                  href: 'https://www.getpostman.com/'
               }, {
                  title: 'LoadRunner',
                  url: __webpack_require__(138),
                  href: 'http://www8.hp.com/cn/zh/software-solutions/loadrunner-load-testing/'
               }, {
                  title: 'Jenkins',
                  url: __webpack_require__(125),
                  href: 'https://jenkins.io/'
               }, {
                  title: 'Travis',
                  url: __webpack_require__(206),
                  href: 'https://travis-ci.org/'
               }, {
                  title: 'Saucelabs',
                  url: __webpack_require__(185),
                  href: 'https://saucelabs.com/'
               }, {
                  title: 'BrowserStack',
                  url: __webpack_require__(79),
                  href: 'https://www.browserstack.com/'
               }]
            }]
         }, {
            website: [{
               name: 'Unix/Linux↓↓↓',
               items: [{
                  title: 'Redhat',
                  url: __webpack_require__(178),
                  href: 'https://www.redhat.com/'
               }, {
                  title: 'Debian',
                  url: __webpack_require__(87),
                  href: 'https://www.debian.org/'
               }, {
                  title: 'Centos',
                  url: __webpack_require__(80),
                  href: 'https://www.centos.org/'
               }, {
                  title: 'Ubuntu',
                  url: __webpack_require__(208),
                  href: 'http://www.ubuntu.com/'
               }, {
                  title: 'Arch',
                  url: __webpack_require__(67),
                  href: 'https://www.archlinux.org/'
               }, {
                  title: 'Gentoo',
                  url: __webpack_require__(100),
                  href: 'https://www.gentoo.org/'
               }]
            }, {
               name: '博主推荐↓↓↓',
               items: [{
                  title: 'WhyCSS',
                  url: __webpack_require__(214),
                  href: 'http://whycss.com/'
               }, {
                  title: '简书',
                  url: __webpack_require__(126),
                  href: 'http://www.jianshu.com/'
               }, {
                  title: 'SegmentFault',
                  url: __webpack_require__(189),
                  href: 'https://segmentfault.com/'
               }, {
                  title: 'Div',
                  url: __webpack_require__(89),
                  href: 'http://div.io/'
               }, {
                  title: 'Hostucan',
                  url: __webpack_require__(115),
                  href: 'https://www.hostucan.cn/'
               }]
            }, {
               name: '博主常用↓↓↓',
               items: [{
                  title: 'Zealer',
                  url: __webpack_require__(221),
                  href: 'http://www.zealer.com/'
               }, {
                  title: '海贼王',
                  url: __webpack_require__(121),
                  href: 'http://www.ishuhui.com/cartoon/book/1/'
               }, {
                  title: '苹果团',
                  url: __webpack_require__(66),
                  href: 'http://www.appletuan.com/'
               }, {
                  title: '知乎',
                  url: __webpack_require__(223),
                  href: 'https://www.zhihu.com/'
               }, {
                  title: '开源中国',
                  url: __webpack_require__(164),
                  href: 'http://www.oschina.net/'
               }]
            }]
         }]
      };
   },

   methods: {
      toggleMenuList: function toggleMenuList() {
         this.pageBoolean.showMenu = !this.pageBoolean.showMenu;
      },
      toggleLangList: function toggleLangList() {
         this.pageBoolean.showLang = !this.pageBoolean.showLang;
      }
   },
   mounted: function mounted() {
      var self = this;
      this.$nextTick(function () {
         document.title = "黑工具导航";
      });
   }
};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_page_Home__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_page_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_page_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_page_Intro__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_page_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_page_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_page_Advantage__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_page_Advantage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_page_Advantage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_page_Contact__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_page_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_page_Contact__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ exports["default"] = {
  data: function data() {
    return {
      meanList: [{
        text: '主页',
        select: true, //hover
        clicked: true, //click
        enter: false,
        leave: false
      }, {
        text: '介绍及初印象',
        select: false,
        clicked: false,
        enter: false,
        leave: false
      }, {
        text: '优势及特长',
        select: false,
        clicked: false,
        enter: false,
        leave: false
      }, {
        text: '联系方式',
        select: false,
        clicked: false,
        enter: false,
        leave: false
      }],
      pageBoolean: {
        showMenu: false, //菜单
        showLang: false, //国际化
        showLoad: true //加载中
      }
    };
  },

  methods: {
    toggleMenuList: function toggleMenuList() {
      this.pageBoolean.showMenu = !this.pageBoolean.showMenu;
    },
    toggleLangList: function toggleLangList() {
      this.pageBoolean.showLang = !this.pageBoolean.showLang;
    },
    mouseOverForSmall: function mouseOverForSmall(index) {
      for (var i = 0, len = this.meanList.length; i < len; i++) {
        if (index == i) {
          this.meanList[i]['select'] = true;
        } else {
          this.meanList[i]['select'] = false;
        }
      }
      //console.log('移进'+index);
    },
    mouseOutForSmall: function mouseOutForSmall(index) {
      this.meanList[index]['select'] = false;
    },
    navigatorTo: function navigatorTo(index) {
      var meanList = this.meanList,
          currentIndex = 0;
      for (var i = 0, len = meanList.length; i < len; i++) {
        if (meanList[i]['clicked']) {
          this.meanList[i]['leave'] = true;
          currentIndex = i;
        } else {
          this.meanList[i]['leave'] = false;
        }
        this.meanList[i]['enter'] = false;
        this.meanList[i]['clicked'] = false;
      }
      //console.log('从'+currentIndex+'到'+index);
      //index去的页面pt-page-scaleUp
      this.meanList[index]['enter'] = true;
      this.meanList[index]['clicked'] = true;
    }
  },
  mounted: function mounted() {
    //console.log('showing');
    var self = this;
    this.$nextTick(function () {
      document.title = "吴伟的主页";
      self.meanList[0]['select'] = false;
    });
  },

  components: {
    Home: __WEBPACK_IMPORTED_MODULE_0_components_page_Home___default.a,
    Intro: __WEBPACK_IMPORTED_MODULE_1_components_page_Intro___default.a,
    Advantage: __WEBPACK_IMPORTED_MODULE_2_components_page_Advantage___default.a,
    Contact: __WEBPACK_IMPORTED_MODULE_3_components_page_Contact___default.a
  }
};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_page_Tool__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_page_Tool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_page_Tool__);
//
//
//
//



/* harmony default export */ exports["default"] = {
  components: {
    Tool: __WEBPACK_IMPORTED_MODULE_0_components_page_Tool___default.a
  }
};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(33), __esModule: true };

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(31);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(59);
module.exports = __webpack_require__(10).Object.assign;

/***/ },
/* 34 */
/***/ function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(14)
  , toLength  = __webpack_require__(55)
  , toIndex   = __webpack_require__(54);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ },
/* 37 */
/***/ function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(34);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(4)
  , document = __webpack_require__(3).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ },
/* 40 */
/***/ function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

var global    = __webpack_require__(3)
  , core      = __webpack_require__(10)
  , ctx       = __webpack_require__(38)
  , hide      = __webpack_require__(43)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ },
/* 42 */
/***/ function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(46)
  , createDesc = __webpack_require__(51);
module.exports = __webpack_require__(1) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(1) && !__webpack_require__(2)(function(){
  return Object.defineProperty(__webpack_require__(39)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(49)
  , gOPS     = __webpack_require__(47)
  , pIE      = __webpack_require__(50)
  , toObject = __webpack_require__(56)
  , IObject  = __webpack_require__(12)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(2)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(35)
  , IE8_DOM_DEFINE = __webpack_require__(44)
  , toPrimitive    = __webpack_require__(57)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(1) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ },
/* 47 */
/***/ function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

var has          = __webpack_require__(42)
  , toIObject    = __webpack_require__(14)
  , arrayIndexOf = __webpack_require__(36)(false)
  , IE_PROTO     = __webpack_require__(52)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(48)
  , enumBugKeys = __webpack_require__(40);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ },
/* 50 */
/***/ function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ },
/* 51 */
/***/ function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

var shared = __webpack_require__(53)('keys')
  , uid    = __webpack_require__(58);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

var global = __webpack_require__(3)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(13)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(13)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(11);
module.exports = function(it){
  return Object(defined(it));
};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(4);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ },
/* 58 */
/***/ function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(41);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(45)});

/***/ },
/* 60 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 61 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 62 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7glink.11b03d27.png";

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aliyun.df106a9c.jpg";

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/angular.a4bff3f1.png";

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/appletuan.d5076938.png";

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arch.6e789c34.png";

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/atom.8098a46e.ico";

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/aws.32edd489.png";

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/axure.f7284609.png";

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/azure.12e3dac8.ico";

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/babel.5e61d42f.png";

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/baidu.77304d0c.png";

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/beecloud.f6676cbf.ico";

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bitbucket.1964dbe0.ico";

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bmob.daf9660b.ico";

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bootstrap.43e1b655.png";

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bower.49341509.png";

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/browserstack.d6fb1daf.png";

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/centos.5837a49c.png";

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/charles.378ffdb5.png";

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chrome.8daafc83.ico";

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/codepen.77efadfd.png";

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/coding.6566dc67.png";

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cordova.5cbd6586.png";

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/crosswalk.2c6e91f2.ico";

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/debian.992f49ae.png";

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/digitalocean.310de8d8.png";

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/div.56c872da.ico";

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/docker.14d3907a.png";

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eclipse.64b7105f.png";

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/edge.8ea8e880.png";

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/emacs.8a19b9c2.png";

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/expressjs.20ad1ef0.png";

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fastclick.abcb7716.png";

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firebase.1c16b537.png";

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/firefox.223e1bca.png";

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fontawesome.c2c3993e.ico";

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/frozen.83761e86.png";

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gentoo.d5837fb6.png";

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/git.6a80a853.png";

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/github.6b4b0b35.png";

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gitlab.994b56df.png";

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/go.f3bb2609.png";

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google.f42e68fa.png";

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/greenplumdb.7bd150d2.png";

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grunt.dc580e12.png";

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gulp.e51e5551.png";

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hadoop.d5e39b9d.png";

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hammer.01be87fb.png";

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hapi.cc02a01e.png";

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hbuilder.1149723d.png";

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/heroku.03eb3e6f.png";

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hexo.521f4748.png";

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hostucan.bb49e955.png";

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iconfont.6773320d.ico";

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iis.046d68fe.png";

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/intel.bc58c045.png";

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ionic.449e070a.png";

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iscroll.1910fb0a.png";

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ishuhui.e9c2c9f9.png";

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jasmine.359fc809.png";

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/java.f9c26bfb.png";

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jekyllrb.236d4c44.png";

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jenkins.62c38a30.png";

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jianshu.58fd04f6.png";

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jquery.4b1ef75f.png";

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jquerymobile.03c56eb8.png";

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jsfiddle.1663aa37.png";

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/junit.dcef2b90.png";

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/karma.5d9da521.png";

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/koa.c9266453.png";

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lantern.6634ca6f.png";

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/leancloud.54b86336.png";

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/less.59d487be.png";

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/letsencrypt.f7a7de83.png";

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/linode.3f87a86f.png";

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loadrunner.24d8f398.png";

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/localtunnel.9b9881a9.ico";

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loopBack.a3801832.png";

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lovefield.2baa38f3.png";

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mahua.e54fec8d.png";

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mariadb.0bbba1b2.png";

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/memcached.7339e977.png";

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mercurial.3ad5c23a.png";

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/meteor.3157bb99.png";

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mocha.4665ed02.png";

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modao.b3317d93.ico";

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mongodb.d416519f.png";

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mysql.e7600bc4.png";

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/natapp.ecec5ea9.png";

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nativescript.835462e0.png";

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/netbeans.8d38a6fc.png";

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/netlify.f993bf1e.png";

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nginx.6e4f1eee.png";

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ngrok.af62d12d.png";

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nodejs.e87d5cff.png";

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/nodesecurity.e33b0ee9.png";

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/normalize.c2a7a2f3.png";

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/notepad.8da5ace9.png";

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/openshift.867253d1.png";

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opera.635d9409.png";

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/oracle.079ef52b.png";

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/oschina.a88702cd.png";

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pagekite.bb8118d2.png";

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/php.35a8645d.png";

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pingxx.5f0f586f.ico";

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/polymer.4c572d99.png";

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/postgresql.0bf66b03.png";

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/postman.4dab9f25.png";

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pug.3e58f7f5.png";

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/purecss.597aac9f.ico";

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/python.5c93be7e.png";

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/qiniu.54cc9783.png";

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/qunitjs.c99de3f1.ico";

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/react-native.214edac7.png";

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/react.9f58696a.png";

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/redhat.c74a8f11.png";

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/redis.a3ac72e8.png";

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/require.cff6ef41.png";

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ruby.80a5e190.png";

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/safari.3f2f3e56.png";

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sails.19647a16.png";

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sass.515644bb.png";

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/saucelabs.95a4a40c.png";

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sea.63345552.png";

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/selenium.e3a8cc80.png";

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/semantic.d6658ee9.png";

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sf.5092c1c5.png";

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shadowsocks.c4ccdf32.png";

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sketch.c007d565.png";

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/socket.io.571d8a1d.png";

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/softether.271b46c4.ico";

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sqlite.d322ff82.png";

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sqlserver.90396714.png";

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/startssl.6406961e.png";

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/stylus.40a2cf6a.png";

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sublime.8a483f7a.png";

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/surge.32abfb1c.png";

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/svn.8f635f1d.png";

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/swift.d7945167.png";

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/swiper.2428d691.png";

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tencent-cloud.f6c9ad6f.png";

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tomcat.415cd59d.png";

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tor-logo.50b84031.png";

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/travis.d14b010e.png";

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/twilio.ed2c1b56.png";

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ubuntu.3f3d48ac.png";

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vim.40c677f7.png";

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vscode.b11c0550.png";

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vue.e1ea82cb.png";

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/webpack.d1e458c2.png";

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/webstorm.e00a3773.png";

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/whycss.6298277a.png";

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wn8.5bdb5375.png";

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xcode.8b982e13.png";

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xx-net.da0f3235.png";

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yegou.f17ec1fc.png";

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yeoman.83c46c72.png";

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yunpian.7508a04a.png";

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zealer.697da073.png";

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zfb.b2da8476.ico";

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhihu.87c020b9.png";

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zybuluo.9d468ba5.png";

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.5c74ce70.png";

/***/ },
/* 226 */
/***/ function(module, exports) {

var appCacheIframe;

function hasSW() {
  return 'serviceWorker' in navigator &&
    // This is how I block Chrome 40 and detect Chrome 41, because first has
    // bugs with history.pustState and/or hashchange
    (window.fetch || 'imageRendering' in document.documentElement.style) &&
    (window.location.protocol === 'https:' || window.location.hostname === 'localhost')
}

function install(options) {
  options || (options = {});

  
    if (hasSW()) {
      var registration = navigator.serviceWorker
        .register(
          "/sw.js"
          
        );

      
        var handleUpdating = function(registration) {
          var sw = registration.installing || registration.waiting;
          var ignoreInstalling;
          var ignoreWaiting;

          // No SW or already handled
          if (!sw || sw.onstatechange) return;

          var stateChangeHandler;

          // Already has SW
          if (registration.active) {
            onUpdateStateChange();
            stateChangeHandler = onUpdateStateChange;
          } else {
            onInstallStateChange();
            stateChangeHandler = onInstallStateChange;
          }

          ignoreInstalling = true;
          if (registration.waiting) {
            ignoreWaiting = true;
          }

          sw.onstatechange = stateChangeHandler;

          function onUpdateStateChange() {
            switch (sw.state) {
              case 'redundant': {
                sendEvent('onUpdateFailed');
                sw.onstatechange = null;
              } break;

              case 'installing': {
                if (!ignoreInstalling) {
                  sendEvent('onUpdating');
                }
              } break;

              case 'installed': {
                if (!ignoreWaiting) {
                  sendEvent('onUpdateReady');
                }
              } break;

              case 'activated': {
                sendEvent('onUpdated');
                sw.onstatechange = null;
              } break;
            }
          }

          function onInstallStateChange() {
            switch (sw.state) {
              case 'redundant': {
                // Failed to install, ignore
                sw.onstatechange = null;
              } break;

              case 'installing': {
                // Installing, ignore
              } break;

              case 'installed': {
                // Installed, wait activation
              } break;

              case 'activated': {
                sendEvent('onInstalled');
                sw.onstatechange = null;
              } break;
            }
          }
        };

        var sendEvent = function(event) {
          if (typeof options[event] === 'function') {
            options[event]({
              source: 'ServiceWorker'
            });
          }
        };

        registration.then(function(reg) {
          // WTF no reg?
          if (!reg) return;

          // Installed but Shift-Reloaded (page is not controller by SW),
          // update might be ready at this point (more than one tab opened).
          // Anyway, if page is hard-reloaded, then it probably already have latest version
          // but it's not controlled by SW yet. Applying update will claim this page
          // to be controlled by SW. Maybe set flag to not reload it?
          // if (!navigator.serviceWorker.controller) return;

          handleUpdating(reg);
          reg.onupdatefound = function() {
            handleUpdating(reg);
          };
        }).catch(function(err) {
          sendEvent('onError');
          return Promise.reject(err);
        });
      

      return;
    }
  

  
}

function applyUpdate(callback, errback) {
  
    if (hasSW()) {
      navigator.serviceWorker.getRegistration().then(function(registration) {
        if (!registration || !registration.waiting) {
          errback && errback();
          return;
        }

        registration.waiting.postMessage({
          action: 'skipWaiting'
        });

        callback && callback();
      });

      return;
    }
  

  
}

exports.install = install;
exports.applyUpdate = applyUpdate;

/***/ },
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(62)

/* template */
var __vue_template__ = __webpack_require__(245)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* script */
__vue_exports__ = __webpack_require__(24)

/* template */
var __vue_template__ = __webpack_require__(244)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* script */
__vue_exports__ = __webpack_require__(25)

/* template */
var __vue_template__ = __webpack_require__(241)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(61)

/* script */
__vue_exports__ = __webpack_require__(26)

/* template */
var __vue_template__ = __webpack_require__(242)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* script */
__vue_exports__ = __webpack_require__(27)

/* template */
var __vue_template__ = __webpack_require__(238)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(60)

/* script */
__vue_exports__ = __webpack_require__(28)

/* template */
var __vue_template__ = __webpack_require__(240)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* script */
__vue_exports__ = __webpack_require__(29)

/* template */
var __vue_template__ = __webpack_require__(239)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* script */
__vue_exports__ = __webpack_require__(30)

/* template */
var __vue_template__ = __webpack_require__(243)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },
/* 238 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-2', 'mod-intro',
      _vm.meanList[1].clicked ? 'pt-page-current' : '',
      _vm.meanList[1].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[1].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-intro"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-section-intro content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("Web（3YEARS/ING）")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("Java（1YEAR）")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n    经历：企业后台管理、定制网站网页、IPTV平板、微信公众号、微信小程序。"), _c('br'), _vm._v("\n    应用及框架：MySQL、Spring、SpringMVC、Hibernate、JQuery、Sea、Cordova、Zepto、Vue。"), _c('br'), _vm._v("\n    接触过：SVN、Java、JavaScript、HTML、CSS、Hexo、Coding、GitHub、阿里云、七牛云\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "infoText_2 anim"
  }, [_vm._v("\n    我喜欢coding，但不专注于当专家级别，我想要的是宽度而不是深度。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper anim"
  }, [_c('a', {
    staticClass: "cta button",
    attrs: {
      "href": "https://www.vmartaw.com/zcc/2017/02/09/2017%E5%B9%B4%E6%AF%8F%E4%B8%80%E4%B8%AA%E4%B8%8D%E6%9B%BE%E8%B5%B7%E8%88%9E%E7%9A%84%E6%97%A5%E5%AD%90%E9%83%BD%E6%98%AF%E5%AF%B9%E7%94%9F%E5%91%BD%E7%9A%84%E8%BE%9C%E8%B4%9F/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("每一个不曾起舞的日子都是对生命的辜负")])])]), _vm._v(" "), _c('div', {
    staticClass: "award anim"
  })])
}]}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "wrapper as"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    class: ['mod-navigation', _vm.pageBoolean.showMenu ? 'open' : '']
  }, [_c('div', {
    staticClass: "nav-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleMenuList($event)
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    class: ['lang-switch', _vm.pageBoolean.showLang ? 'open' : '']
  }, [_c('span', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleLangList($event)
      }
    }
  }, [_vm._v("ZH-CN")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('ul', {
    staticClass: "menuList"
  }, _vm._l((_vm.meanList), function(item, index) {
    return _c('li', [_c('a', {
      class: [item.select ? 'active' : '', , item.clicked ? 'active' : ''],
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.navigatorTo(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])])
  })), _vm._v(" "), _c('ul', {
    staticClass: "metaList"
  }, [_vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "tool"
    }
  }, [_c('span', [_vm._v("黑工具导航(已开放)")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "pagecontrol"
  }, [_c('div', {
    staticClass: "tool-tip-wrapper"
  }, _vm._l((_vm.meanList), function(item, index) {
    return _c('span', {
      class: ['tool-tip', item.select ? 'active' : '']
    }, [_vm._v(_vm._s(item.text))])
  })), _vm._v(" "), _c('ol', {
    staticClass: "pager"
  }, _vm._l((_vm.meanList), function(item, index) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          _vm.mouseOverForSmall(index)
        },
        "mouseout": function($event) {
          _vm.mouseOutForSmall(index)
        },
        "click": function($event) {
          _vm.navigatorTo(index)
        }
      }
    }, [_c('a', {
      class: [item.select ? 'active' : '', item.clicked ? 'active' : '']
    }, [_c('span', [_vm._v(_vm._s(item.text))])])])
  }))]), _vm._v(" "), _vm._v(">")]), _vm._v(" "), _c('div', {
    staticClass: "pt-perspective",
    attrs: {
      "id": "pt-main"
    }
  }, [_c('div', {
    staticClass: "content main page-start"
  }, [_c('home', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  }), _vm._v(" "), _c('intro', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  }), _vm._v(" "), _c('advantage', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  }), _vm._v(" "), _c('contact', {
    attrs: {
      "page-boolean": _vm.pageBoolean,
      "mean-list": _vm.meanList
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: ['mod-overlay-loading', _vm.pageBoolean.showLoad ? 'startload' : '']
  }, [_vm._m(10)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod-logo"
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": "start.html"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "src": __webpack_require__(225)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/de-DE/start.html"
    }
  }, [_c('span', [_vm._v("GER")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/en-DE/start.html"
    }
  }, [_c('span', [_vm._v("ENG")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/es-ES/start.html"
    }
  }, [_c('span', [_vm._v("ESP")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/nl-NL/start.html"
    }
  }, [_c('span', [_vm._v("NLD")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/fi-FI/start.html"
    }
  }, [_c('span', [_vm._v("FIN")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/zh-TW/start.html"
    }
  }, [_c('span', [_vm._v("ZH-TW")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/zh-CN/start.html"
    }
  }, [_c('span', [_vm._v("ZH-CN")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/ko-KR/start.html"
    }
  }, [_c('span', [_vm._v("KOR")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/pt-BR/start.html"
    }
  }, [_c('span', [_vm._v("BRA")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/cs-CZ/start.html"
    }
  }, [_c('span', [_vm._v("CZE")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/ja-JP/start.html"
    }
  }, [_c('span', [_vm._v("JPN")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/fr-FR/start.html"
    }
  }, [_c('span', [_vm._v("FRA")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/it-IT/start.html"
    }
  }, [_c('span', [_vm._v("ITA")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/se-SE/start.html"
    }
  }, [_c('span', [_vm._v("SWE")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://www.vmartaw.com/zcc/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("博主的黑科技(已开放)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("音乐的聆听者")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("海贼王的男人")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("回忆的沙漏")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("环游的甜蜜时光")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("儿时的梦想")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("永不止步")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#metadata"
    }
  }, [_c('span', [_vm._v("探味人生")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arc-rotate2"
  }, [_c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "arc"
  })])])
}]}

/***/ },
/* 240 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tool"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.allSite), function(row) {
    return _c('section', {
      staticClass: "row"
    }, _vm._l((row["website"]), function(category) {
      return _c('div', {
        staticClass: "tool-container"
      }, [_c('div', {
        staticClass: "tool-name"
      }, [_vm._v(_vm._s(category.name))]), _vm._v(" "), _c('ul', {
        staticClass: "tool-type-ul"
      }, _vm._l((category["items"]), function(item) {
        return _c('li', {
          key: "index"
        }, [_c('a', {
          attrs: {
            "href": item.href,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": item.url,
            "title": item.title
          }
        })])])
      }))])
    }))
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tool-title"
  }, [_c('span', {
    staticClass: "toolList"
  }, [_vm._v("Web全栈开发导航，持续更新，可收藏本页面")])])
}]}

/***/ },
/* 241 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-2', 'mod-how_works',
      _vm.meanList[3].clicked ? 'pt-page-current' : '',
      _vm.meanList[3].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[3].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-how_works"
    }
  }, [_c('div', {
    staticClass: "mod-section-how-works content-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "base clearfix anim"
  }, [_c('div', {
    staticClass: "step-1"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('svg', {
    staticClass: "svg replaced-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Ebene_1",
      "data-name": "Ebene 1",
      "viewbox": "0 0 107.75 53"
    }
  }, [_c('title', [_vm._v("icon_01")]), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "1.5",
      "y": "1.5",
      "width": "30.67",
      "height": "50",
      "rx": "5",
      "ry": "5"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "16.8",
      "cy": "43.8",
      "r": "2.6"
    }
  }), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "75.58",
      "y": "9.6",
      "width": "30.67",
      "height": "37",
      "rx": "5",
      "ry": "5"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M99.12 25.21H85.84v-5.14A2.17 2.17 0 0 1 88 17.9h9a2.17 2.17 0 0 1 2.17 2.17v5.14z",
      "transform": "translate(-1.56 -16.34)"
    }
  }), _c('path', {
    staticClass: "cls-3",
    attrs: {
      "d": "M81.29 48.68v2.75M100.29 48.68v2.75M53.35 18.85L61 26.5l-7.65 7.65M61 26.5H45.63"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        手机号：15828274523\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "step-2"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('svg', {
    staticClass: "svg replaced-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Ebene_1",
      "data-name": "Ebene 1",
      "viewbox": "0 0 33.67 82.58"
    }
  }, [_c('title', [_vm._v("icon_02")]), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "1.5",
      "y": "1.5",
      "width": "30.67",
      "height": "79.58",
      "rx": "5",
      "ry": "5"
    }
  }), _c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M26.9 34.81H7.52M26.9 41.81H7.52M26.9 48.81H7.52M24.21 26.5V7.13M17.21 26.5V7.13M10.21 26.5V7.13"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        QQ：1061087497（昵称空）\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "step-3"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('svg', {
    staticClass: "svg replaced-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Ebene_1",
      "data-name": "Ebene 1",
      "viewbox": "0 0 53.88 46.77"
    }
  }, [_c('title', [_vm._v("icon_03")]), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "6.54",
      "y": "1.5",
      "width": "37",
      "height": "30.67",
      "rx": "5",
      "ry": "5"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M72.77 42.93V29.65h5.14a2.17 2.17 0 0 1 2.17 2.17v8.95a2.17 2.17 0 0 1-2.17 2.17h-5.14z",
      "transform": "translate(-28.5 -19.45)"
    }
  }), _c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M4.46 7.21H1.71M4.46 26.21H1.71M52.38 42.13H1.5M24.68 9.19l7.65 7.64-7.65 7.65M32.33 16.83H16.96M4.44 45.27v-2.43M14.44 45.27v-2.43M24.44 45.27v-2.43M34.44 45.27v-2.43M44.44 45.27v-2.43M9.44 45.27v-2.43M19.44 45.27v-2.43M29.44 45.27v-2.43M39.44 45.27v-2.43M49.44 45.27v-2.43"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        微信：ww-930912（昵称阿伟）\n      ")])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("联系方式：")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-wrapper anim"
  }, [_c('a', {
    staticClass: "cta button",
    attrs: {
      "href": "https://www.vmartaw.com/zcc/about.html",
      "target": "_blank",
      "title": ""
    }
  }, [_vm._v("关于我的")])])
}]}

/***/ },
/* 242 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-1',
      _vm.meanList[0].clicked ? 'pt-page-current' : '',
      _vm.meanList[0].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[0].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-home"
    }
  }, [_c('div', {
    staticClass: "mod-bg-video covervid-wrapper loop",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_vm._m(0), _vm._v(" "), _c('video', {
    staticClass: "covervid-video",
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)",
      "height": "auto",
      "width": "1320px"
    },
    attrs: {
      "id": "loopVideo",
      "loop": "'true'",
      "muted": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "canplay": _vm.canplay
    }
  }, [_c('source', {
    attrs: {
      "src": "../media/160329_Rimowa_Topas_Loop_v2_2000.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    class: ['mod-bg-video', 'covervid-wrapper', 'full', _vm.currentBoolean.isFullPlay ? 'anim' : 'animout'],
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.closeFullPlay
    }
  }, [_c('span'), _c('span')]), _vm._v(" "), _c('video', {
    staticClass: "covervid-video",
    staticStyle: {
      "position": "absolute",
      "top": "50%",
      "left": "50%",
      "transform": "translate(-50%, -50%)",
      "height": "auto",
      "width": "1860px"
    },
    attrs: {
      "id": "fullVideo"
    },
    on: {
      "timeupdate": _vm.progressBarVal
    }
  }, [_c('source', {
    attrs: {
      "src": "../media/160329_Rimowa_Topas_Loop_v2_2000.mp4",
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('div', {
    class: ['controls', _vm.currentBoolean.isFullPlay ? 'active' : '']
  }, [_c('span', {
    staticClass: "btnPlay",
    on: {
      "click": _vm.toggleFullPlay
    }
  }, [_c('i', {
    class: [_vm.currentBoolean.toggleFullPlay ? 'icon-Play' : 'icon-Pause']
  })]), _vm._v(" "), _c('span', {
    staticClass: "volumen",
    on: {
      "click": _vm.toggleFullPlayMuted
    }
  }, [_c('i', {
    class: [_vm.currentBoolean.toggleFullPlayMuted ? 'icon-Sound_off' : 'icon-Sound_on']
  })]), _vm._v(" "), _c('span', {
    staticClass: "progressBar",
    attrs: {
      "id": "fullBar"
    },
    on: {
      "click": _vm.getProgressBar
    }
  }, [_c('span', {
    staticClass: "duration",
    style: (_vm.progressWidth)
  }, [_c('span', {
    staticClass: "currentTime"
  })]), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.pageText.time))])])])]), _vm._v(" "), _c('div', {
    staticClass: "mod-section-home content-container"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "video-btn-wrapper"
  }, [_c('div', {
    staticClass: "video-btn",
    on: {
      "click": _vm.canFullPlay
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        我是一个追求自由的人。财务自由，精神自由。虽然我现在只是一个伪全栈开发工程师，但是我相信未来肯定会更好。\n      ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "close"
  }, [_c('span'), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controls"
  }, [_c('span', {
    staticClass: "btnPlay"
  }, [_c('i', {
    staticClass: "icon-Pause"
  })]), _c('span', {
    staticClass: "volumen"
  }, [_c('i', {
    staticClass: "icon-Sound_on"
  })]), _c('span', {
    staticClass: "progressBar"
  }, [_c('span', {
    staticClass: "duration"
  }, [_c('span', {
    staticClass: "currentTime"
  })]), _c('span', {
    staticClass: "time"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claim anim"
  }, [_c('span', {
    staticClass: "logo"
  }), _vm._v(" "), _c('p', [_vm._v("\n          保持饥饿，保持愚蠢\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("欢迎来到吴伟的主页")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("里面有你所需要的。")])])])])
}]}

/***/ },
/* 243 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tool')
},staticRenderFns: []}

/***/ },
/* 244 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-1', 'mod-benefits',
      _vm.meanList[2].clicked ? 'pt-page-current' : '',
      _vm.meanList[2].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[2].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-benefits"
    }
  }, [_c('div', {
    class: ['mod-section-benefits', _vm.pageClass.pageNow]
  }, [_c('div', {
    class: ["inner-section", "content-first", "slide", "",
      _vm.currentBoolean.isTwo ? "pt-page-moveToLeft" : "",
      _vm.currentBoolean.isOne ? "pt-page-scaleUp pt-slide-current" : ""
    ]
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    class: ["inner-section", "content-second", "slide",
      _vm.currentBoolean.isTwo ? "pt-page-scaleUp pt-slide-current" : "",
      _vm.currentBoolean.isOne ? "pt-page-moveToRight" : "",
      _vm.currentBoolean.isThree ? "pt-page-moveToLeft" : ""
    ]
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    class: ["inner-section", "content-third", "slide",
      _vm.currentBoolean.isThree ? "pt-page-scaleUp pt-slide-current" : ""
    ]
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "benefits-nav"
  }, [_c('div', {
    staticClass: "benefits-nav-line"
  }, [_c('span', {
    staticClass: "label left"
  }, [_vm._v("简单介绍")]), _vm._v(" "), _c('span', {
    staticClass: "line-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "label middle"
  }, [_vm._v("个人展示")]), _vm._v(" "), _c('span', {
    staticClass: "line-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "label right"
  }, [_vm._v("得意作品")]), _vm._v(" "), _c('span', {
    staticClass: "marker left active",
    on: {
      "click": function($event) {
        _vm.turnPage(0)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "marker middle",
    on: {
      "click": function($event) {
        _vm.turnPage(1)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "marker right",
    on: {
      "click": function($event) {
        _vm.turnPage(2)
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('span', {
    staticClass: "arrow arrow-left",
    on: {
      "click": function($event) {
        _vm.turnLeft()
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "/images/icons/benefits-arrow-left.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "arrow arrow-right",
    on: {
      "click": function($event) {
        _vm.turnRight()
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "/images/icons/benefits-arrow-right.png"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("熟练使用各类前端框架")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("目前在用Vue.js、微信小程序")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        运用各类前端框架，根据其优势和不足熟练运用到不同的项目或创业中。"), _c('br'), _vm._v("\n        JavaScript作用于浏览器，熟练使用原生JS、JQuery、Zepto对应插件及框架；JavaScript作用于WebView、内置App，熟练使用Vue、Cordova、微信小程序；JavaScript作用于服务器端，了解Node.js。\n        熟练使用HTML、CSS进行页面的制作，酷炫复杂自定义动画不会。\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("我是要成为")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("海贼王的男人。")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        我是出生在一个很普通的农村家庭，从小学会做什么事必须靠自己，如果想要生活得更好，自己就必须加倍的努力。用几个词语形容自己的话，那就是：时尚屌丝、成熟的有点过分、智商超群、情商为零、做事认真负责、向往自由…\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("App：一起玩吧")])])]), _c('span', {
    staticClass: "second"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', {
    staticClass: "anim"
  }, [_vm._v("网站：个人博客")])])])]), _vm._v(" "), _c('p', {
    staticClass: "infoText anim"
  }, [_vm._v("\n        一起玩吧：以玩会友，人这辈子真心朋友不多，希望通过该App能让大家找到真心朋友。"), _c('br'), _vm._v("\n        博客：自己的练级之地，除了前端技术方面，还有生活、健身、自己的思想等各个方面。\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "active-marker"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "/images/icons/benefits-marker-active.png"
    }
  })])
}]}

/***/ },
/* 245 */
/***/ function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_css_main_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_css_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_css_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__promise_polyfill__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__(18);




// enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(20);
}

__WEBPACK_IMPORTED_MODULE_2__app__["a" /* app */].$mount('#app');

/***/ }
],[246]);


// WEBPACK FOOTER //
// client.6f912c1d.js